import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"

import {
  Navigator,
  Home,
  WaveBackground,
  About,
  Footer,
  Inspiration,
  PrivacyPolicy,
} from "../components"

export default function App(props) {
  const [showPrivacy, setShowPrivacy] = useState(false)

  useEffect(() => {
    document.body.style.overflowY = showPrivacy ? "hidden" : "scroll"
  }, [showPrivacy])

  useEffect(() => {
    if (window.location.hash === "#privacy") {
      setShowPrivacy(true)
    }
  }, [])

  return (
    <div style={{ maxWidth: "100vw", overflow: "hidden" }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Meritas</title>
        <link rel="canonical" href="https://getmeritas.netlify.app/" />
      </Helmet>
      <Navigator  showPrivacy={() => setShowPrivacy(true)} />
      <Home imgs={props.data.allFile.edges} />
      <About />
      <Inspiration />
      <Footer showPrivacy={() => setShowPrivacy(true)} />
      <WaveBackground />
      <PrivacyPolicy
        show={showPrivacy}
        hidePrivacy={() => setShowPrivacy(false)}
      />
    </div>
  )
}

export const query = graphql`
  query {
    allFile(
      filter: {
        relativePath: { in: ["screenshot.png", "graph-screenshot.png"] }
      }
    ) {
      edges {
        node {
          childImageSharp {
            # Specify the image processing specifications right in the query.
            # Makes it trivial to update as your page's design changes.
            fixed(width: 360, height: 360) {
              ...GatsbyImageSharpFixed_noBase64
            }
          }
        }
      }
    }
  }
  # query {
  #   file(relativePath: { ne: "images/screenshot.png" }) {
  #     publicURL
  #   }
  # }
`
